<script>
    import { trainerTexts as texts } from './trainerTexts';
    export let lang;
    import { createEventDispatcher } from 'svelte';
    import { trainerTools } from './trainertools.js';
    const dispatch = createEventDispatcher();
    import Swal from 'sweetalert2';
    // import Swal from 'sweetalert2';
    export let game;
    const selectTexts = {
        pl: 'Wybierz  język',
        eng: 'Choose language',
    };
    const langSelectPrefs = {
        title: 'Wybierz język',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#233e63',
        cancelButtonColor: '#941728',
        cancelButtonText: 'English',
        confirmButtonText: 'Polski',
    };

    async function selectLang() {
        langSelectPrefs.title = selectTexts[lang];
        let language = await Swal.fire(langSelectPrefs);
        let gameLang;
        if (language.isConfirmed) {
            gameLang = 'pl';
        } else gameLang = 'eng';
        return gameLang;
    }

    async function activateGame() {
        const confirmation = await Swal.fire({
            title: texts[lang].you_sure,
            text: texts[lang].cant_change_players,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#233e63',
            cancelButtonColor: '#941728',
            cancelButtonText: texts[lang].cancel_create,
            confirmButtonText: texts[lang].confirm_create,
            backdrop: false,
        });
        if (!confirmation.isConfirmed) return;
        const gameLang = await selectLang();
        const isSuccess = await trainerTools.activateGame(game.code);

        if (isSuccess) {
            localStorage.setItem(game.gameId, JSON.stringify(game.code));
            const gameUrl = `/?mode=${game.gameId}&code=${game.code}&lang=${gameLang}`;
            window.location.assign(gameUrl);
        } else {
            console.log('incorrect activation');
        }
    }

    function addPlayer() {
        if (game.playersCount === 8) {
            Swal.fire('Max graczy to 8');
            return;
        }
        dispatch('addDeletePlayer', {
            gameId: game.gameId,
            gameCode: game.code,
            change: 'add',
        });
    }
    function deletePlayer() {
        if (game.playersCount === 4) {
            Swal.fire('Min graczy to 4');
            return;
        }
        dispatch('addDeletePlayer', {
            gameId: game.gameId,
            gameCode: game.code,
            change: 'delete',
        });
    }
</script>

<div
    class="game"
    class:single-game={!game.isGameOn && !game.isGameEnd}
    class:running={game.isGameOn}
    class:closed={game.isGameEnd}
>
    <div class="section-bar">
        <div class="section-text">
            {texts[lang].game}
            {game.code}
        </div>
        <hr />
    </div>
    <p class="p__game">
        {texts[lang].game_status}
        {#if game.isGameOn && !game.isGameEnd}
            {texts[lang].game_active}
        {:else if game.isGameEnd}
            {texts[lang].game_end}
        {:else}
            {texts[lang].game_inactive}
        {/if}
        <br />
        {texts[lang].players}
        {game.playersCount}
    </p>
    <button
        class="btn btn__smaller"
        disabled={game.isGameOn || game.isGameEnd}
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        on:click={activateGame}
        >{texts[lang].activate_game}
    </button>
    <button
        class="btn btn__smaller"
        class:btn--inactive={!(game.isGameOn && !game.isGameEnd)}
        disabled={!(game.isGameOn && !game.isGameEnd)}
        on:click={async () => {
            const lang = await selectLang();
            window.open(`/?mode=${game.gameId}&code=${game.code}&lang=${lang}`);
        }}
        >{texts[lang].continue_game}
    </button>
    <button
        class="btn btn__smaller"
        class:btn--inactive={!game.isGameEnd}
        disabled={!game.isGameEnd}
        on:click={async () => {
            const lang = await selectLang();
            window.open(`/?mode=${game.gameId}&code=${game.code}&lang=${lang}`);
        }}
        >{texts[lang].show_results}
    </button>
    <button
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        disabled={game.isGameOn || game.isGameEnd}
        on:click={() =>
            dispatch('deleteGame', {
                gameId: game.gameId,
                gameCode: game.code,
            })}
        >{texts[lang].delete_game}
    </button>
    <button
        disabled={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        on:click={addPlayer}
        >{texts[lang].add_player}
    </button>
    <button
        disabled={game.isGameOn || game.isGameEnd}
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        on:click={deletePlayer}
        >{texts[lang].subtr_player}
    </button>
</div>
